export class Access {
    id?: number;
    code?: string;
    name?: string;
    icon?: string;
}

export class VerificationCode{
    code: number;
}
